(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ph-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.phInitialised === 'true') return;

    root.dataset.phInitialised = 'true';

    var elements = root.querySelectorAll('[data-ph-reveal]');

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      elements.forEach(function (element) {
        element.classList.add('is-in');
      });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.12
      });

      elements.forEach(function (element, index) {
        element.style.transitionDelay = (index % 3) * 90 + 'ms';
        observer.observe(element);
      });
    }

    var track = root.querySelector('[data-ph-track]');
    var bar = root.querySelector('[data-ph-bar]');

    if (track && bar) {
      var updateProgress = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;

        var progress = maxScroll > 0
          ? track.scrollLeft / maxScroll
          : 0;

        var visibleRatio = track.scrollWidth > 0
          ? track.clientWidth / track.scrollWidth
          : 1;

        var barWidth = Math.min(1, Math.max(0.12, visibleRatio));

        bar.style.width = (barWidth * 100) + '%';

        bar.style.transform =
          'translateX(' +
          (progress * (1 / barWidth - 1) * 100) +
          '%)';
      };

      track.addEventListener('scroll', updateProgress, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(updateProgress);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateProgress);
      }

      updateProgress();
    }
  }

  function boot(scope) {
    var context = scope || document;

    if (context.matches && context.matches('.ph-rev')) {
      init(context);
    }

    if (context.querySelectorAll) {
      context.querySelectorAll('.ph-rev').forEach(function (root) {
        init(root);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
